export interface iColorsTheme {
  primary: string;
  primaryDark: string;
  primaryLight: string;
  primary200: string;
}

export type iThemeTypes =
  | 'CARGILL'
  | 'ACELEN'
  | 'IRANCHO'
  | 'WALMART'
  | 'MINERVA'
  | 'INTERSTATE_MEAT_DISTRIBUTORS'
  | 'SAFETRACE'
  | 'QIMA'
  | 'ASSAI'
  | 'THOMAS_FOODS'
  | 'GRAOSDOPARA'

export interface iTheme {
  favicon: string;
  title: string;
  code: iThemeTypes;
  colors: iColorsTheme;
}

export const themes = new Map<iThemeTypes, iTheme>([
  [
    'CARGILL',
    {
      favicon: 'assets/images/cargill/favicon.ico',
      title: 'Cargill',
      code: 'CARGILL',
      colors: {
        primary: '#008542',
        primaryDark: '#006622',
        primaryLight: '#40ca84',
        primary200: '#b5e7a0',
      },
    },
  ],
  [
    'ACELEN',
    {
      favicon: 'assets/images/acelen/favicon.png',
      title: 'Acelen',
      code: 'ACELEN',
      colors: {
        primary: '#0074fc',
        primaryDark: '#0f52a0',
        primaryLight: '#1d85ff',
        primary200: '#80b5f2',
      },
    },
  ],
  [
    'IRANCHO',
    {
      favicon: 'assets/images/irancho/favicon.png',
      title: 'iRancho',
      code: 'IRANCHO',
      colors: {
        primary: '#3c471b',
        primaryDark: '#2C3F17',
        primaryLight: '#5E6039',
        primary200: '#AB9F93',
      },
    },
  ],
  [
    'WALMART',
    {
      favicon: 'assets/images/walmart/favicon.webp',
      title: 'Walmart',
      code: 'WALMART',
      colors: {
        primary: '#0073d5',
        primaryDark: '#000EA5',
        primaryLight: '#22A9DE',
        primary200: '#44D7E5',
      },
    },
  ],
  [
    'MINERVA',
    {
      favicon: 'assets/images/minerva/favicon.png',
      title: 'Minerva',
      code: 'MINERVA',
      colors: {
        primary: '#C92026',
        primaryDark: '#981C20',
        primaryLight: '#EE454B',
        primary200: '#e49093',
      },
    },
  ],
  [
    'INTERSTATE_MEAT_DISTRIBUTORS',
    {
      favicon: 'assets/images/interstate-meat/favicon.webp',
      title: 'Interstate Meat Distributors',
      code: 'INTERSTATE_MEAT_DISTRIBUTORS',
      colors: {
        primary: '#C92026',
        primaryDark: '#981C20',
        primaryLight: '#EE454B',
        primary200: '#e49093',
      },
    },
  ],
  [
    'QIMA',
    {
      favicon: 'assets/images/qima/favicon.ico',
      title: 'Qima',
      code: 'QIMA',
      colors: {
        primary: '#C92026',
        primaryDark: '#981C20',
        primaryLight: '#EE454B',
        primary200: '#e49093',
      },
    },
  ],
  [
    'SAFETRACE',
    {
      favicon: 'assets/images/safetrace/favicon.ico',
      title: 'Safetrace',
      code: 'SAFETRACE',
      colors: {
        primary: '#008542',
        primaryDark: '#006622',
        primaryLight: '#40ca84',
        primary200: '#b5e7a0',
      },
    },
  ],
  [
    'THOMAS_FOODS',
    {
      favicon: 'assets/images/thomas-foods/favicon.webp',
      title: 'Thomas Foods',
      code: 'THOMAS_FOODS',
      colors: {
        primary: '#008542',
        primaryDark: '#006622',
        primaryLight: '#40ca84',
        primary200: '#b5e7a0',
      },
    },
  ],
  [
    'ASSAI',
    {
      favicon: 'assets/images/assai/favicon.png',
      title: 'Assaí',
      code: 'ASSAI',
      colors: {
        primary: '#C92026',
        primaryDark: '#981C20',
        primaryLight: '#EE454B',
        primary200: '#e49093',
      },
    },
  ],
  [
    'GRAOSDOPARA',
    {
      favicon: 'assets/images/safetrace/favicon.ico',
      title: 'Grãos do Pará',
      code: 'GRAOSDOPARA',
      colors: {
        primary: '#4e8030',
        primaryDark: '#3b683a',
        primaryLight: '#79b177',
        primary200: '#cee5cd',
      },
    }
  ]
]);
